import React, {useEffect, useState} from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import importacaoHistoricoStyle from "assets/jss/material-dashboard-pro-react/views/importacaoHistoricoStyle.jsx";
import {DropzoneAreaBase} from 'material-ui-dropzone'
import ReactTable from "../../components/ReactTableWrapper";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileDownload, faSearchPlus, faSpinner, faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import connection from "../../connection";
import general from "../../general";
import SweetAlert from "../../components/SweetAlertWrapper";
import modeloImportacao from "../../assets/static/MODELO_IMPORTACAO.xlsx";

const ImportacaoHistorico = (props) => {
  const {classes} = props;

  const [importacoes, setImportacoes] = useState([]);
  const [modal, setModal] = useState(null);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    connection.get('administracao/importacao_historico').then(setImportacoes)
  }, []);

  const apagarImportacao = (id) => {
    setModal(<SweetAlert
      warning
      title="Remover Importação"
      onConfirm={async () => {
        await connection.post("administracao/importacao_historico/" + id + "/apagar");
        connection.get('administracao/importacao_historico').then(setImportacoes);
        setModal(null)
      }}
      onCancel={() => setModal(null)}
      confirmBtnCssClass={
        classes.button + " " + classes.danger
      }
      cancelBtnCssClass={
        classes.button
      }
      confirmBtnText="Apagar"
      cancelBtnText="Cancelar"
      showCancel
    >
      Quer apagar a importação com o ID {id}?
    </SweetAlert>)
  }

  return <div>
    {modal}
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="primary">
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
              <h4 style={{flex: 1}}>Nova importação
                <a href={modeloImportacao} className={classes.downloadExemplo}><small><FontAwesomeIcon icon={faFileDownload}/> Descarregar exemplo</small></a>
              </h4>
            </div>
          </CardHeader>
          <DropzoneAreaBase
            acceptedFiles={['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']}
            filesLimit={1}
            dropzoneText={<>Arraste para aqui o ficheiro com os dados para criar uma nova importação {uploading && <p><br/> <FontAwesomeIcon icon={faSpinner} spin style={{marginLeft: 10}}/> Aguarde</p>}</>}
            onAdd={async (files) => {
              let form_data = new FormData();
              form_data.append("excel", files[0].file);
              setUploading(true)
              try {
                let resultado = await connection.post("administracao/importacao_historico/nova", form_data, null, null, {returnError: true});
                window.App.hist.push("/importacao_historico/" + resultado.id_importacao);
                general.success("Importação criada com sucesso")
              } catch (e) {
              }
              setUploading(false)
            }}
            showAlerts={false}
            fileObjects={[]}
            classes={{root: classes.dropzoneRoot + (uploading ? " " + classes.dropzoneDisabled : "")}}/>
        </Card>
      </GridItem>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="primary">
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
              <h4 style={{flex: 1}}>Importações</h4>
            </div>
          </CardHeader>
          <ReactTable
            placeholder={"Ainda não foi feita nenhuma importação"}
            data={importacoes}
            minRows={1}
            columns={[
              {
                Header: "ID",
                accessor: "id",
                width: 80
              },
              {
                Header: "Data de Criação",
                accessor: "data_criacao",
                Cell: ({value}) => general.Renderers.dateRenderer(value, {hide_timezone: true})
              },
              {
                Header: "Terminado",
                accessor: "data_finalizacao",
                Cell: ({value}) => value ? <>Sim ({general.Renderers.dateRenderer(value, {hide_timezone: true})})</> : "-"
              },
              {
                Header: "Cursos",
                accessor: "cursos",
                Cell: ({value}) => value.join(", ")
              },
              {
                Header: "Utilizador",
                accessor: "utilizador",
                width: 150,
                Cell: general.Renderers.userRenderer
              },
              {
                Header: "",
                accessor: "id",
                maxWidth: 105,
                sortable: false,
                filterable: false,
                Cell: ({value: id, original}) => <React.Fragment>
                  <Button
                    justIcon
                    round
                    simple
                    onClick={() => {
                      window.App.hist.push("/importacao_historico/" + id);
                    }}
                    style={{margin: 0}}
                    color="info"
                    className="edit"
                  >
                    <FontAwesomeIcon icon={faSearchPlus}/>
                  </Button>
                  {!original.data_finalizacao && <Button
                    justIcon
                    round
                    simple
                    style={{margin: 0}}
                    onClick={() => {
                      apagarImportacao(id)
                    }}
                    color="danger"
                    className="edit"
                  >
                    <FontAwesomeIcon icon={faTrashAlt}/>
                  </Button>}
                </React.Fragment>
              }
            ]}
            defaultPageSize={10}
            showPaginationBottom={true}
            className="-striped -highlight"
          />
        </Card>
      </GridItem>
    </GridContainer>
  </div>;
}

export default withStyles(importacaoHistoricoStyle)(ImportacaoHistorico);
